import http from "@/services/http";
import { defineStore } from "pinia";
import { ref } from 'vue';
import router from '@/router/index.js';

export const useAuth = defineStore('auth', () => {
    const token = ref(localStorage.getItem('token'));
    const admin = ref(JSON.parse(localStorage.getItem('admin') || 'null'));

    function setToken(tokenValue) {
        localStorage.setItem('token', tokenValue);
        token.value = tokenValue;
    }

    function setAdmin(adminValue) {
        localStorage.setItem('admin', JSON.stringify(adminValue));
        admin.value = adminValue;
    }

    function getBearer() {
        return { headers: { Authorization: "Bearer " + token.value } };
    }

    // Confere não só se o token é válido, mas se pertence de fato a um
    // admin — um token de lojista/operador vazado aqui recebe 403 do
    // middleware `admin` da API e cai no mesmo tratamento de "não autenticado".
    async function checkAuth() {
        try {
            await http.get('/admin/me', getBearer());
            return true;
        } catch (error) {
            console.log(error?.response?.data);
            return false;
        }
    }

    function logout() {
        setToken('');
        setAdmin(null);
        router.push({ name: 'login' });
    }

    return { token, admin, setToken, setAdmin, checkAuth, getBearer, logout }
})
